import React from 'react';
import classNames from 'classnames';
import {
  Node,
} from '@uncinc/react-drupal-core';

const ExpertPublications = ({ entities, args }) => {
  if (!entities) {
    return null;
  }
  return (
    <div className="col-12">
      {entities.count() > 0 && <h4>Externe publicaties</h4>}
      {entities.map((item, index) => {
        const id = item.getIn(['nid', 0, 'value']);
        const langcode = item.getIn(['langcode', 0, 'value']);
        const classes = classNames('ExpertPublications__row');

        return (
          <div key={`${id}:${langcode}`} className={classes}>
            <Node
              viewMode="teaser"
              key={id}
              id={item.getIn(['nid', 0, 'value'])}
              entity={item}
            />
          </div>
        );
      },
      )}
    </div>
  );
};

export default ExpertPublications;
